import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import {ISSUE_TYPES_UPDATE_ACTIONS} from '../../../constants/issue-types';

class IssueTypesAddAttributesLeaveModal extends PureComponent {
  constructor(props) {
    super(props);

    this.updateActionKeys = Object.keys(ISSUE_TYPES_UPDATE_ACTIONS);

    this.state = {
      ...this.getUpdateActionsStatusInitialized()
    };

    this.onSave = this.onSave.bind(this);
    this.updateActionStatusAndCloseModal = this.updateActionStatusAndCloseModal.bind(this);
  }

  getUpdateActionsStatusInitialized() {
    return this.updateActionKeys.reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
  }

  updateActionStatusAndCloseModal(action) {
    this.setState(
      {
        [action]: true
      },
      () => {
        if (this.updateActionKeys.every(key => this.state[key] === true)) {
          this.props.showIssueTypeUpdatedNotificationAction(this.props.isIssueSubType);
          this.props.closeModal({shouldOpenAddAttributesModal: false});
        }
      }
    );
  }

  onSave() {
    const onSuccessUpdateIssueType = () => {
      this.updateActionStatusAndCloseModal(ISSUE_TYPES_UPDATE_ACTIONS.ISSUE_TYPE);
    };
    const onSuccessUpdateIssueTypeMappings = () => {
      this.updateActionStatusAndCloseModal(ISSUE_TYPES_UPDATE_ACTIONS.ISSUE_TYPE_MAPPINGS);
    };
    this.props.updateIssueTypeAction(onSuccessUpdateIssueType, onSuccessUpdateIssueTypeMappings);
  }

  render() {
    return (
      <ModalConfirmation
        container={this.props.container}
        show={this.props.isOpen}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
        isOnConfirmInProgress={this.props.isSaving}
        confirmationButtonLabelInProgress={i18n.t('issueTypes.modal.saving')}
        confirmationButtonLabel={i18n.t('issueTypes.modal.saveAndLeave')}
        cancelButtonLabel={i18n.t('issueTypes.modal.continueEditing')}
        onHide={() => this.props.closeModal()}
        onExited={() => this.props.closeModal({isExited: true})}
        onConfirm={this.onSave}
        title={i18n.t('issueTypes.modal.leaveIssueTypeEdit')}
        message={i18n.t('issueTypes.modal.leaveIssueTypeEditMessage')}
      />
    );
  }
}

IssueTypesAddAttributesLeaveModal.displayName = 'IssueTypesAddAttributesLeaveModal';

IssueTypesAddAttributesLeaveModal.propTypes = {
  isSaving: PropTypes.bool,
  container: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isIssueSubType: PropTypes.bool,
  updateIssueTypeAction: PropTypes.func.isRequired,
  showIssueTypeUpdatedNotificationAction: PropTypes.func.isRequired
};

export default IssueTypesAddAttributesLeaveModal;
